import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { PartnerProduct, ProductStatisticResponse } from '../interfaces/partner-product.interface';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Observable } from 'rxjs';
import { LoggerService } from './logger.service';

export interface PartnerProductParams {
  order_by?: string;
  order?: string;
  skip?: number;
  limit?: number;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class PartnerProductsService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('partner-product');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) {}

  /** GET /partner-product — public list */
  getList(params?: PartnerProductParams): Observable<GenericResponseWithTotal<PartnerProduct>> {
    return this.http.get<GenericResponseWithTotal<PartnerProduct>>(this.apiUrl, {
      params: this.dataProcess.fitlerParams(params),
    });
  }

  /** POST /partner-product — create */
  create(data: Partial<PartnerProduct>): Observable<PartnerProduct> {
    return this.http.post<PartnerProduct>(this.apiUrl, data);
  }

  /** GET /partner-product/admin/list — admin list */
  getAdminList(params?: PartnerProductParams): Observable<GenericResponseWithTotal<PartnerProduct>> {
    return this.http.get<GenericResponseWithTotal<PartnerProduct>>(`${this.apiUrl}/admin/list`, {
      params: this.dataProcess.fitlerParams(params),
    });
  }

  /** GET /partner-product/current/list — current user's partner products */
  getCurrentList(params?: PartnerProductParams): Observable<GenericResponseWithTotal<PartnerProduct>> {
    return this.http.get<GenericResponseWithTotal<PartnerProduct>>(`${this.apiUrl}/current/list`, {
      params: this.dataProcess.fitlerParams(params),
    });
  }

  /** GET /partner-product/sort — reorder items */
  changeSort(item_id: number, direction: 'UP' | 'DOWN'): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/sort`, {
      params: { item_id: item_id.toString(), direction },
    });
  }

  /** GET /partner-product/{item_id} — single item */
  getById(item_id: number): Observable<PartnerProduct> {
    return this.http.get<PartnerProduct>(`${this.apiUrl}/${item_id}`);
  }

  /** PUT /partner-product/{item_id} — update */
  update(item_id: number, data: Partial<PartnerProduct>): Observable<PartnerProduct> {
    return this.http.put<PartnerProduct>(`${this.apiUrl}/${item_id}`, data);
  }

  /** DELETE /partner-product/{item_id} — delete */
  delete(item_id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${item_id}`);
  }

  /** POST /partner-product/upload — upload image file */
  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  /** GET /partner-product/download/{filename} — download file URL */
  getDownloadUrl(filename: string): string {
    return `${this.apiUrl}/download/${encodeURIComponent(filename)}`;
  }
  
    getProductStatistics(product_id: number): Observable<ProductStatisticResponse> {
      return this.http.get<ProductStatisticResponse>(`${this.apiUrl}/statistics/${product_id}`);
    }
}


